export default __webpack_public_path__ + "static/cloud-native_03-d178e9f6b90b0b01d90c2b843126e122.png";